import React from 'react';
import styled from 'styled-components';

import { padding, fonts } from '../GlobalStyle';
import { calc4k } from '../utilities';

export default function FeaturedEvents({ events, featuredEvents }) {
    return (
        <Container>
            <NoEventsContainer>
                <NoEventsText>
                    No {events.length ? 'more' : ''} events for today
                </NoEventsText>
            </NoEventsContainer>
            <>
                {featuredEvents[0] && (
                    <FeaturedEvent>
                        <ImageContainer image={featuredEvents[0].img} />
                        <EventDescContainer>
                            <EventDescTopContainer>
                                <EventDescTopLeft>COMING UP</EventDescTopLeft>
                                <EventDescTopRight>
                                    {featuredEvents[0].time}
                                </EventDescTopRight>
                            </EventDescTopContainer>
                            <EventDescBottom>
                                {featuredEvents[0].title}
                            </EventDescBottom>
                        </EventDescContainer>
                    </FeaturedEvent>
                )}
            </>
            <>
                {featuredEvents[1] && (
                    <FeaturedEvent>
                        <ImageContainer image={featuredEvents[1].img} />
                        <EventDescContainer>
                            <EventDescTopContainer>
                                <EventDescTopLeft>COMING UP</EventDescTopLeft>
                                <EventDescTopRight>
                                    {featuredEvents[1].time}
                                </EventDescTopRight>
                            </EventDescTopContainer>
                            <EventDescBottom>
                                {featuredEvents[1].title}
                            </EventDescBottom>
                        </EventDescContainer>
                    </FeaturedEvent>
                )}
            </>
            <>
                {featuredEvents[2] && (
                    <FeaturedEvent>
                        <ImageContainer image={featuredEvents[2].img} />
                        <EventDescContainer>
                            <EventDescTopContainer>
                                <EventDescTopLeft>COMING UP</EventDescTopLeft>
                                <EventDescTopRight>
                                    {featuredEvents[2].time}
                                </EventDescTopRight>
                            </EventDescTopContainer>
                            <EventDescBottom>
                                {featuredEvents[2].title}
                            </EventDescBottom>
                        </EventDescContainer>
                    </FeaturedEvent>
                )}
            </>
        </Container>
    );
}

const Container = styled.div`
    flex-direction: column;
`;

const NoEventsContainer = styled.div`
    position: relative;
    height: ${calc4k(763)};
    font-size: ${calc4k(50)};
    font-weight: ${calc4k(50)};
    background-color: black;
    color: #d8d8d8;
    /* color: #afafaf; */
`;

const NoEventsText = styled.div`
    font-family: ${fonts.headline};
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const FeaturedEvent = styled.div`
    border-top: 1px solid #383736;
    display: flex;
    height: ${calc4k(950)};
    padding: ${calc4k(211)} 0 ${calc4k(211)} ${padding.side};
`;

const ImageContainer = styled.div`
    width: ${calc4k(600)};
    height: ${calc4k(500)};
    background-image: url(${p => p.image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
`;

const EventDescContainer = styled.div`
    font-family: ${fonts.headline};
    display: flex;
    flex-direction: column;
    width: ${calc4k(1328)};
    padding-left: ${padding.side};
`;

const EventDescTopContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const EventDescTopLeft = styled.div`
    font-family: ${fonts.headline};
    color: #afafaf;
    text-transform: uppercase;
    font-size: ${calc4k(50)};
    font-weight: 500;
`;

const EventDescTopRight = styled.div`
    font-family: ${fonts.headline};
    font-size: ${calc4k(50)};
    font-weight: 500;
`;

const EventDescBottom = styled.div`
    margin-top: ${calc4k(50)};
    font-size: ${calc4k(80)};
    line-height: ${calc4k(140)};
    font-weight: 500;
`;
